module.exports = __webpack_public_path__ + "static/media/CLASSROOM-TO-CAREER-blog4.f8b5008e.jpg";